import React from 'react';
import CustomerError from '../../../components/CustomerError';
import {UserType} from '../../../hooks/apis/useUser';
import UseContestNotice from '../../../hooks/apis/useContestNotice';
import {Breadcrumb, Card, message} from 'antd';
import QuickRouter from '../../../utils/QuickRouter';
import useAuth from '../../../utils/AuthContext';
import ContestNoticeEditForm, {IContestNoticeEditForm} from '../../../components/ContestNotice/EditForm';
import useQuickRouter from '../../../utils/QuickRouter';
import CommonApiErrorHandler from '../../../utils/HttpInstance';
import {useParams} from 'react-router-dom';

export default function ManageContestNoticeNewPage() {
  const auth = useAuth();
  const saveState = UseContestNotice.save();
  const params = useParams() as {contestId?: string};
  const routeQueryContestId = params?.contestId || '';
  const quickRouter = useQuickRouter();

  function save(form: IContestNoticeEditForm) {
    saveState
      .request({...form, publishedDate: form.publishedDate.format(), contestId: parseInt(routeQueryContestId)})
      .then(() => {
        message.success('操作成功');
        return quickRouter.manageContestNoticeList(parseInt(routeQueryContestId));
      })
      .catch(CommonApiErrorHandler);
  }

  if (!auth.currentUser || auth.currentUser.type !== UserType.管理员) return <CustomerError title={'无操作权限'} />;
  return (
    <div>
      <Breadcrumb className={'mb-md'}>
        <Breadcrumb.Item>
          <a onClick={quickRouter.index}>首页</a>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <a onClick={() => quickRouter.manageContestNoticeList(parseInt(routeQueryContestId))}>通知列表</a>
        </Breadcrumb.Item>
      </Breadcrumb>
      <Card title={'新建通知'}>
        <ContestNoticeEditForm isLoading={saveState.loading} onFinish={save} />
      </Card>
    </div>
  );
}
